import React from "react";
import Header from "./Header";
import NavBar from "./AppBar";
import Products from "./Products";
import AboutUs from "./About";
import ContactUs from "./Contact";

export default function Home() {
    return (
        <>
            <NavBar />
            <Header />
            <Products/>
            <AboutUs />
            <ContactUs />
          
        </>
    )
}